export class SupportTicketApi {
    client;
    constructor(client) {
        this.client = client;
    }
    async createTicket(params) {
        return this.client.post('/api/support/tickets', params);
    }
    async listTickets(params) {
        const qs = new URLSearchParams();
        if (params?.page)
            qs.set('page', String(params.page));
        if (params?.limit)
            qs.set('limit', String(params.limit));
        const query = qs.toString();
        return this.client.get(`/api/support/tickets${query ? `?${query}` : ''}`);
    }
    async getUnreadCount() {
        return this.client.get('/api/support/unread-count');
    }
    async getTicket(ticketId) {
        return this.client.get(`/api/support/tickets/${encodeURIComponent(ticketId)}`);
    }
    async addComment(ticketId, params) {
        return this.client.post(`/api/support/tickets/${encodeURIComponent(ticketId)}/comments`, params);
    }
    async resolveTicket(ticketId, params) {
        return this.client.post(`/api/support/tickets/${encodeURIComponent(ticketId)}/resolve`, params);
    }
}
//# sourceMappingURL=support-ticket-api.js.map